import {Component, inject, OnInit, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RepoService} from "../services/repo.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {object} from "@angular/fire/database";
import {MerAccordionComponent} from "./mer-accordion/mer-accordion.component";

@Component({
  selector: 'app-category-prices',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MerAccordionComponent,
  ],
  templateUrl: './category-prices.component.html',
  styleUrl: './category-prices.component.scss'
})
export class CategoryPricesComponent implements OnInit {

  public repoService = inject(RepoService);
  public snackBar = inject(MatSnackBar);

  subscriptionsEditable = signal<Map<string, Map<string, Object>> | null>(null);
  subscriptionsOriginal = signal<Map<string, Map<string, Object>> | null>(null);

  items = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5'];
  protected readonly Map = Map;
  protected readonly object = object;

  ngOnInit(): void {
    this.repoService.listenToCategoryPrices().subscribe(data => {
      if (data) {
        this.subscriptionsOriginal.set(JSON.parse(JSON.stringify(data)));
        this.subscriptionsEditable.set(data);
      }
    })
  }

  async saveData() {
    try {
      await this.repoService.updatePrices({data: this.subscriptionsEditable()})
      this.snackBar.open("Data saved successfully!", "Close", {
        duration: 4000,
        horizontalPosition: "end",
        verticalPosition: "top"
      })
    } catch (e) {

      this.snackBar.open("Error!", "Close", {duration: 4000, horizontalPosition: "end", verticalPosition: "top"})
      return e;
    }
  }
}
